import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { withStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import * as DeviceActionCreators from '../../../actions/device'

class HydraLock extends React.Component {
  static propTypes = {
    device: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired,
  }

  static mapDispatchToProps(dispatch) {
    return {
      deviceActions: bindActionCreators(DeviceActionCreators, dispatch),
    }
  }

  static styles = {}

  onRestart = () => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'restart')
  }

  onIdent = () => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'ident')
  }

  onUnlock = () => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'unlock')
  }

  onDoorbell = () => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'doorbell')
  }

  render() {
    return (
      <>
        <Button onClick={this.onRestart}>Restart</Button>
        <Button onClick={this.onIdent}>Identify</Button>
        <Button onClick={this.onUnlock}>Unlock</Button>
        <Button onClick={this.onDoorbell}>Doorbell</Button>
      </>
    )
  }
}

export default connect(
  HydraLock.mapStateToProps,
  HydraLock.mapDispatchToProps,
)(withStyles(HydraLock.styles)(HydraLock))
